module.exports = __webpack_public_path__ + "media/images/logo/Logo(V)_Grey-ed29cb57450d1e3509c890c83fb0acef.png";